<template>
  <div class="forgotNewPassword">
    <loading-primary v-if="isPageLoading"/>
    <div v-if="tokenValid" class="forgotNewPassword__wrapper">
      <h2 class="small-title title">Input your new password</h2>
      <adx-form
        @complete="onComplete($event)"
        :schema="schema"
        :model.sync="model"
        :error.sync="error"
        :onSubmit="onSubmit"
        :wrapper="wrapper" />
    </div>
    <div class="forgotNewPassword__wrapper--error" v-if="!isPageLoading && !tokenValid">
      <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="140" height="140" viewBox="0 0 140 140">
        <defs>
            <path id="a" d="M7.292 24.806h5.833c.875 0 1.458-.437 1.458-1.312v-.145c0-8.31 7.146-15.162 15.604-14.579 7.73.583 13.563 7.29 13.563 15.162v-.438c0 .875.583 1.312 1.458 1.312h5.834c.875 0 1.458-.437 1.458-1.312v-.145C52.5 10.082 41.417-.561 28 .023 15.604.606 6.125 11.103 5.833 23.494c.146.73.73 1.312 1.459 1.312zm-1.459-1.312v.584-.584zm52.5 12.975c0-3.207-2.625-5.831-5.833-5.831H5.833C2.625 30.638 0 33.262 0 36.469v27.7C0 67.376 2.625 70 5.833 70H52.5c3.208 0 5.833-2.624 5.833-5.831v-27.7zM35.875 59.358c.292.874-.438 1.895-1.458 1.895H23.77c-1.021 0-1.604-.875-1.459-1.895l2.625-8.747c-2.187-1.458-3.5-4.082-3.062-6.998.583-2.77 2.77-4.957 5.688-5.54 4.666-.875 8.75 2.478 8.75 6.852 0 2.332-1.167 4.52-3.063 5.686l2.625 8.747z"/>
        </defs>
        <g fill="none" fill-rule="evenodd">
            <circle cx="70" cy="70" r="70" fill="#E5E5EA"/>
            <circle cx="70" cy="70" r="58.333" fill="#FF3B30" fill-opacity=".6"/>
            <use fill="#FFF" transform="rotate(-15 160.355 -105.497)" xlink:href="#a"/>
        </g>
      </svg>
      <h2 class="title small-title">Oops, Reset password has expired</h2>
      <h6 class="description subhead">it look like your link for reset password has already use.</h6>
    </div>
  </div>
</template>

<script>
import FormAbstraction from '@/components/Form'
import LoadingPrimary from '@/components/Loading/Primary'

import api from '@/api'
import types from '@/lib/types'
import { apiV2 } from '@/api/urls'
const {
  ButtonType: { BUTTON, RESET },
  ButtonAction: { SUBMIT, APICALL, GOTO }
} = types

export default {
  name: 'adx-forgot-new-password',
  components: {
    'adx-form': FormAbstraction,
    'loading-primary': LoadingPrimary,
  },
  props: {

  },
  data() {
    return {
      isPageLoading: false,
      tokenValid: false,
      wrapper: {
        alertWrapper: `content`
      },
      model: {
        email: ``,
        new_password: ``,
        confirm_password: ``,
        uid: ``
      },
      error: {

      },
      onSubmit: {
        wrapper: {
          class: ``
        },
        buttons: [
          {
            type: BUTTON,
            action: SUBMIT,
            label: `Change Password`,
            uri: apiV2.setNewPassword,
            params: this.model,
            method: `post`,
            class: `btn-block secondary signin`,
            isLoading: false
          },
        ]
      },
      schema: [
        {
          type: 'hidden',
          fields: [
            {
              type: 'input',
              inputType: 'hidden',
              model: 'email'
            },
            {
              type: 'input',
              inputType: 'hidden',
              model: 'uid'
            }
          ]
        },
        {
          type: 'block',
          fields: [
            {
              type: 'input',
              inputType: 'password',
              label: 'New Password',
              model: 'new_password',
              method: 'onChange',
              validation: ['NotEmpty', 'MinLength:6']
            }
          ]
        },
        {
          type: 'block',
          fields: [
            {
              type: 'input',
              inputType: 'password',
              label: 'Retype Password',
              model: 'confirm_password',
              method: 'onChange',
              validation: ['NotEmpty', 'MinLength:6']
            }
          ]
        },
      ]
    }
  },
  computed: {

  },
  watch: {
    '$route' (to, from) {
      const { query } = to
      if (query.email && query.uid) {
        this.tokenValid = true
        this.setModel(query)
      }
    }
  },
  beforeCreate() {
    
  },
  created() {
    const { query } = this.$route
    if (query) {
      const { identifier } = query
      if (identifier === 'reset_new_password' || identifier === 'set_new_password') {
        this.validateToken(query)
      }
    }
  },
  beforeMount() {

  },
  mounted() {

  },
  beforeUpdate() {

  },
  updated() {

  },
  activated() {

  },
  deactivated() {

  },
  beforeDestroy() {

  },
  destroyed() {

  },
  methods: {
    onComplete ({ action, args }) {
      if (args.status === 200) {
        this.$router.replace({name: 'forgotsuccess'})
      }
    },
    setModel ({ email, uid }) {
      this.model.email = email
      this.model.uid = uid
    },
    validateToken (body) {
      (async () => {
        this.isPageLoading = true;
        const response = await api.post(apiV2.emailTokenValidation, body)
        if (response.status == 201) {
          this.isPageLoading = false
          this.$router.replace({path: response.data.redirect_to})
        } else if (response.status == 400) {
          this.isPageLoading = false
          const { errors } = response.data
          Object.keys(errors).forEach((element) => {
            this.$notify({
              group: 'saved',
              title: 'Bad Request',
              text: `${errors[element]}`,
              type: 'danger'
            })
          });
          if (Object.keys(errors).includes('token')) {
            this.tokenValid = false
          }
        }
      })();
    }
  }
}
</script>

<style lang='scss' scoped>
@import './index.scss';
</style>